import { _ as _call_super } from "@swc/helpers/_/_call_super";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _instanceof } from "@swc/helpers/_/_instanceof";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { isMissingValue } from '../api/Missing.js';
import { MissingFormatRange } from './internal/MissingFormat.js';
import { TemporalUtils } from './internal/TemporalUtils.js';
var keyFromTimeZone = function keyFromTimeZone(timeZone) {
    return timeZone.toLowerCase();
};
/**
 * Proxy for {@link Intl.DateTimeFormat} that formats `null` and `undefined` as missing values.
 * It also adds support for {@link Temporal.Instant} and {@link Temporal.ZonedDateTime},
 * and will respect the offset in specific values if present.
 */ export var DateTimeMissingFormat = /*#__PURE__*/ function(MissingFormatRange) {
    "use strict";
    _inherits(DateTimeMissingFormat, MissingFormatRange);
    function DateTimeMissingFormat(localesOrFormat, options) {
        _class_call_check(this, DateTimeMissingFormat);
        var _this;
        _this = _call_super(this, DateTimeMissingFormat, [
            _instanceof(localesOrFormat, Intl.DateTimeFormat) ? localesOrFormat : new Intl.DateTimeFormat(localesOrFormat, options),
            options
        ]);
        Object.defineProperty(_this, 'tzMap', {
            value: new Map()
        });
        _this.tzMap.set(keyFromTimeZone(_this.wrapped.resolvedOptions().timeZone), _this.wrapped);
        return _this;
    }
    var _proto = DateTimeMissingFormat.prototype;
    _proto.format = function format(value) {
        if (isMissingValue(value)) {
            return this.missing;
        }
        return this.zoned(value).format(TemporalUtils.toDate(value));
    };
    _proto.formatToParts = function formatToParts(value) {
        if (isMissingValue(value)) {
            return [
                {
                    type: 'missing',
                    value: this.missing
                }
            ];
        }
        return this.zoned(value).formatToParts(TemporalUtils.toDate(value));
    };
    _proto.formatRange = function formatRange(start, end) {
        var fmt = this.zoned(start);
        return fmt.formatRange(TemporalUtils.toDate(start), TemporalUtils.toDate(end));
    };
    _proto.formatRangeToParts = function formatRangeToParts(start, end) {
        var fmt = this.zoned(start);
        return fmt.formatRangeToParts(TemporalUtils.toDate(start), TemporalUtils.toDate(end));
    };
    _proto.zoned = function zoned(value) {
        // The timeZone is assumed to be a valid IANA time zone ID,
        // since the potential sources (Dayjs, Temporal) are expected to have validated it.
        var timeZone = TemporalUtils.timeZoneFromValue(value);
        if (!timeZone) {
            return this.wrapped;
        }
        var key = keyFromTimeZone(timeZone);
        var zonedFormatter = this.tzMap.get(key);
        if (!zonedFormatter) {
            var options = this.wrapped.resolvedOptions();
            // Should timeZone turn out to be invalid, Intl.DateTimeFormat will throw a RangeError.
            zonedFormatter = new Intl.DateTimeFormat(options.locale, _object_spread_props(_object_spread({}, options), {
                timeZone: timeZone
            }));
            this.tzMap.set(key, zonedFormatter);
        }
        return zonedFormatter;
    };
    return DateTimeMissingFormat;
}(MissingFormatRange);

//# sourceMappingURL=DateTimeMissingFormat.js.map